<template>
  <span class="relative cursor-pointer" @click="open">
    <slot />
    <input
      ref="inputEl"
      type="date"
      :value="modelValue"
      @change="$emit('update:modelValue', $event.target.value)"
      title="Jump to date"
      class="absolute inset-0 w-full h-full opacity-0 cursor-pointer [color-scheme:light] dark:[color-scheme:dark]"
    />
  </span>
</template>

<script setup>
import { ref } from 'vue'

defineProps({ modelValue: { type: String, default: '' } })
defineEmits(['update:modelValue'])

// Chrome only auto-opens a date input's picker when the click lands on its (here invisible)
// calendar-icon glyph, not anywhere in the value area — so clicking the visible label text
// silently did nothing. showPicker() opens it explicitly regardless of where the click landed.
const inputEl = ref(null)
const open = () => {
  try { inputEl.value?.showPicker() } catch {}
}
</script>
